angular.module('rjmNg.api').factory("JoinDefinition", [
  'BaseDefinition'
  'referenceService'
  (BaseDefinition, referenceService) ->

    ###
      foreign-column:
        id: ...
        type: ...
      reference:
        from:
          table: ...
          column: ...
        to:
          table: ...
          column: ...
    ###

    class JoinDefinition extends BaseDefinition

      @definition: 'relocated_field'
      @category: 'oneToMany'
      @arg: 'tableColumn'
      @subtypes: [
          symbol: 'JOINED_COLUMN'
          description: 'A copy of an existing column from another table.'
      ]
      @filtersSupported: true

      @fromColumn: (structure, column, references) ->

        # TODO: load this when multiple references are supported
        # toColumnId = column.properties.joins.local_column_ids[0]
        # fromColumnId = column.properties.joins.foreign_column_ids[0]
        #
        # toColumn = structure.columns[toColumnId]
        # fromColumn = structure.columns[fromColumnId]
        #
        # reference =
        #   from:
        #     column: fromColumnId
        #     table: fromColumn.table_id
        #   to:
        #     column: toColumnId
        #     table: toColumn.table_id

        field = super structure, column, @definition

        columnId = column.properties.source_column_id
        tableId = structure.columns[columnId].table_id

        field.attrs.ref.column = columnId
        field.attrs.ref.table = tableId

        toId = column.properties.joins[0].local_column_ids[0]
        referenceList = referenceService.find(references, column)

        for reference in referenceList when toId is reference.from.column
          field.attrs.reference = reference
          break

        return field

      @toColumn: (structure, table, field) ->

        result = super structure, table, field

        # Make sure this reference is pointing the right way for this table
        reference = field.attrs.reference

        column = structure.columns[field.attrs.ref.column]

        # This makes sure we use the correct direction for the reference
        localColumnId = reference.getLocalColumnId(table)
        foreignColumnId = reference.getForeignColumnId(table)

        result.data_type = column.data_type
        result.old_data_type = column.old_data_type
        result.field_type = if column.field_type? then column.field_type else 'value_general'
        angular.extend(result.properties,
          derivative_type: @definition
          source_column_id: field.attrs.ref.column
          joins: [
            local_column_ids: [localColumnId]
            foreign_column_ids: [foreignColumnId]
          ]
        )

        return result

      @validateReference: (localTableId, field, reference) ->
        reference.from.table is localTableId and reference.to.table is field.attrs.ref.table

      @getSupportedRestrictionTableIds = (localTableId, field) ->
        tableIds = [localTableId]

        if field?.attrs?.ref?.table?
          tableIds.push(field.attrs.ref.table)

        return tableIds

      @getFilterSetProperties: (localTableId, field) ->
        properties =
          tableIds: @getSupportedRestrictionTableIds(localTableId, field)

        if properties.tableIds.length < 2
          properties.warning =
            title: 'Not all filter sets shown'
            message: 'Select an operation table to view all filter sets'

        return properties
  ]
)
